import request from "@/service";

/* 查询所有讲师列表 */
export function getLecturerParamList(params) {
  return request({
    url: `/resource/sys/lecturer/page`,
    method: "get",
    params,
  });
}

/* 根据视频时长获取学时 */
export function getVideoCredit(params) {
  return request({
    url: `/resource/video/info/getVideoCredit`,
    method: "get",
    params,
  });
}

//列表
export function lecturerTypeTree() {
  return request({
    url: `/resource/sys/lecturerType/tree`,
    method: "get",
  });
}

/* 新增 */
export function lecturerSave(data) {
  return request({
    url: `/resource/sys/lecturer/save`,
    method: "post",
    data,
  });
}

/* 编辑 */
export function lecturerEdit(data) {
  return request({
    url: `/resource/sys/lecturer/update`,
    method: "put",
    data,
  });
}

/* 删除 */
export function lecturerDel(data) {
  return request({
    url: `/resource/sys/lecturer/delete`,
    method: "DELETE",
    data,
  });
}

/* 详情 */
export function lectureDetail(params) {
  return request({
    url: `/resource/sys/lecturer/info/${params}`,
    method: "get",
  });
}

// 校验讲师重名
export function validateLecturerName(params) {
  return request({
    url: `/resource/sys/lecturer/validateName/${params}`,
    method: "get",
  });
}
